module.exports = __webpack_public_path__ + "static/media/021.73767769.jpg";